module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-mv-image-2-sp-45ee7b56e11fa0a2cc3502c624bcccb1.png";